import { createReducer } from 'src/utils/reducer'
import * as actions from 'src/constants/actionTypes'

const reduceUser = (acc, user) => ({ ...acc, [user.id]: user })
const users = createReducer(
    {
        byId: {},
        values: [],
        searchResults: [],
        loading: false,
    },
    {
        [actions.GET_RUNBOOKS_SUCCESS]: (state, action) => ({
            ...state,
            byId: {
                ...action.payload.data.results.reduce(
                    (acc, cur) => {
                        let result = cur.createdBy
                            ? reduceUser(acc, cur.createdBy)
                            : { ...acc }
                        cur.admins.forEach((user) => {
                            result = reduceUser(result, user)
                        })
                        return result
                    },
                    { ...state.byId }
                ),
            },
            values: [
                ...action.payload.data.results.reduce(
                    (acc, cur) => [
                        ...acc,
                        cur.createdBy.id,
                        ...cur.admins.map((c) => c.id),
                    ],
                    [...state.values]
                ),
            ].filter((value, index, self) => self.indexOf(value) === index),
        }),
        [actions.GET_CMDB_CONTACTS_SUCCESS]: (state, action) => ({
            ...state,
            byId: {
                ...action.payload.data.results
                    .filter((r) => r.exists)
                    .reduce(reduceUser, { ...state.byId }),
            },
            values: [
                ...state.values,
                ...action.payload.data.results
                    .filter((user) => user.exists)
                    .map((user) => user.id),
            ].filter((value, index, self) => self.indexOf(value) === index),
        }),
        [actions.GET_RUNBOOK_RECEIVED]: (state, action) => ({
            ...state,
            byId: {
                ...action.data.runbook.admins.reduce(
                    (acc, user) => ({
                        ...acc,
                        [user.id]: { ...user, exists: true },
                    }),
                    { ...state.byId }
                ),
            },
            values: [
                ...state.values,
                ...action.data.runbook.admins.map((user) => user.id),
            ].filter((value, index, self) => self.indexOf(value) === index),
        }),
    }
)

export const getUser = (state, userId) => state.users.byId[userId]

export default users
